enum TiposCompra {
    Consumo = 0,
    EstoqueMinimo = 1,
    Venda = 2,
}

export default TiposCompra;
